import React from 'react';
import BodyConditionGroupItem from './BodyConditionGroupItem';

const BodyConditionGroup = (props) => {
  const {images, label, items, reference} = props.data;
  const {output, shouldScreenshot} = props;

  let isSelected = false;
  items.forEach(element => {
    if (parseInt(element.number,10) === output.pet.weight.bcs) {
      isSelected = true;
    }
  });

  const addClass = (isSelected ? 'selected' : '');
  let animalType = output.pet.animalType;
  let animalImages;

  if (animalType == "dog"){
    animalImages = images.dog;
  } else {
    animalImages = images.cat;
  }

  return (
    <div className={'nppe2-fc-feeding-guidelines-body-condition__group--' + reference + ' ' + addClass}>
      <div className={'nppe2-fc-feeding-guidelines-body-condition__group--' + reference + '-txt'}>
        <div className={'nppe2-fc-feeding-guidelines-body-condition__group--' + reference + '-label'}>
          <div>{label}</div>
        </div>

        {items.map((item, index) => (
          <BodyConditionGroupItem
            key={index}
            data={item}
            reference={reference}
            shouldScreenshot={shouldScreenshot}
            animalType={animalType}
          />
        ))}
      </div>

      <div className={'nppe2-fc-feeding-guidelines-body-condition__group--' + reference + '-img'}>
        {animalImages.map((image, index) => (
          <img
            className="img-responsive"
            src={image}
            alt=''
            key={index} />
        ))}
      </div>

    </div>
  );
}

export default BodyConditionGroup;
